export default __webpack_public_path__ + "static/media/WMSLogo.77bae220.svg";